<script>
    import { onMount } from "svelte";
    import { isMobile } from "../../stores";

    import ReconciliationEncounterTab from "./components/ReconciliationEncounterTab.svelte";
    import ReconciliationERAsTab from "./components/ReconciliationERAsTab.svelte";
    import ReconciliationEFTsTab from "./components/ReconciliationEFTsTab.svelte";
    import { replaceURL } from "../../Utils/utilFunctions.svelte";

    export let params = {};

    let currentTab = "";

    onMount(() => {
        if (params.query) updateTab(params.query);
        else currentTab = "ERAs";
    });

    const updateTab = (query) => {
        const arr = query.split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("tab="))
                    currentTab =
                        arr[i].split("=")[1].toLowerCase() == "encounter"
                            ? "ERAs"
                            : arr[i].split("=")[1].toString();
            }
        }
    };

    const updateURL = (tab) => {
        replaceURL(`/Reconciliations/tab=${tab}`);
    };

    // HELPERS FUNCTIONS
    const _showEncounterTab = () => {
        if (currentTab != "encounter") {
            currentTab = "encounter";
            updateURL("encounter");
        }
    };

    const _showERAsTab = () => {
        if (currentTab != "ERAs") {
            currentTab = "ERAs";
            params = {};
            updateURL("ERAs");
        }
    };

    const _showEFTsTab = () => {
        if (currentTab != "EFTs") {
            currentTab = "EFTs";
            params = {};
            updateURL("EFTs");
        }
    };
</script>

<div class="flex flex-1 flex-col gap-y-2">
    {#if $isMobile}
        <div class="tabs w-auto">
            <!-- <p
                class={currentTab == "encounter"
                    ? "tab tab-bordered text-md font-bold tab-active flex-1"
                    : "tab tab-bordered text-md font-bold flex-1"}
                on:click|preventDefault={_showEncounterTab}
            >
                Encounters
            </p> -->

            <p
                class={currentTab == "ERAs"
                    ? "tab tab-bordered text-md font-bold tab-active flex-1"
                    : "tab tab-bordered text-md font-bold flex-1"}
                on:click|preventDefault={_showERAsTab}
            >
                ERAs -> EFTs
            </p>

            <p
                class={currentTab == "EFTs"
                    ? "tab tab-bordered text-md font-bold tab-active flex-1"
                    : "tab tab-bordered text-md font-bold flex-1"}
                on:click|preventDefault={_showEFTsTab}
            >
                EFTs -> Pending Payments
            </p>
        </div>
    {:else}
        <div class="tabs">
            <!-- <p
                class={currentTab == "encounter"
                    ? "tab tab-bordered text-lg font-bold tab-active w-48"
                    : "tab tab-bordered text-lg font-bold w-48"}
                on:click|preventDefault={_showEncounterTab}
            >
                Encounters
            </p> -->

            <p
                class={currentTab == "ERAs"
                    ? "tab tab-bordered text-lg font-bold tab-active w-48"
                    : "tab tab-bordered text-lg font-bold w-48"}
                on:click|preventDefault={_showERAsTab}
            >
                ERAs -> EFTs
            </p>

            <p
                class={currentTab == "EFTs"
                    ? "tab tab-bordered text-lg font-bold tab-active w-72"
                    : "tab tab-bordered text-lg font-bold w-72"}
                on:click|preventDefault={_showEFTsTab}
            >
                EFTs -> Pending Payments
            </p>
        </div>
    {/if}

    <div class="flex flex-1 flex-col">
        <!-- {#if currentTab == "encounter"}
            <ReconciliationEncounterTab {params} /> -->
        {#if currentTab == "ERAs"}
            <ReconciliationERAsTab {params} />
        {:else if currentTab == "EFTs"}
            <ReconciliationEFTsTab {params} />
        {/if}
    </div>
</div>
